import lang from '@/lang'
export const TERMINAL_DESK_STATE = {
  ONLINE_NOT_RUNNING: { label: lang.t('activeOrg.terminalOnline'), type: 'normal' },
  ONLINE_RUNNING: { label: lang.t('activeOrg.deskOnline'), type: 'normal' },
  OFFLINE: { label: lang.t('activeOrg.teminalOffline'), type: 'error' },
  UPGRADING: { label: lang.t('activeOrg.upgrading'), type: 'ing' }
}

export const TERMINAL_DESK_STATE_FILTERS = [
  {
    value: 'ONLINE_NOT_RUNNING',
    text: lang.t('activeOrg.terminalOnline')
  },
  {
    value: 'ONLINE_RUNNING',
    text: lang.t('activeOrg.deskOnline')
  },
  {
    value: 'OFFLINE',
    text: lang.t('activeOrg.teminalOffline')
  },
  {
    value: 'UPGRADING',
    text: lang.t('activeOrg.upgrading')
  }
]

export const TERMINAL_STATE_FILTERS = [
  {
    value: 'remoteAutoAgree',
    text: lang.t('activeOrg.remoteAssisted')
  },
  {
    value: 'openShareStrategy',
    text: lang.t('activeOrg.sharedDeploy')
  },
  {
    value: 'unDeploy',
    text: lang.t('activeOrg.unDeploy')
  }
]
